var map = {
	"./aiutoCompitiDeselected.svg": [
		70716,
		[
			716
		]
	],
	"./arteEImmagineDeselected.svg": [
		75695,
		[
			5695
		]
	],
	"./biologiaDeselected.svg": [
		19141,
		[
			9141
		]
	],
	"./biotecnologieDeselected.svg": [
		9596,
		[
			9596
		]
	],
	"./chimicaAnaliticaEStrumentaleDeselected.svg": [
		37548,
		[
			7548
		]
	],
	"./chimicaDeselected.svg": [
		65365,
		[
			5365
		]
	],
	"./chimicaOrganicaEBiochimicaDeselected.svg": [
		6960,
		[
			6960
		]
	],
	"./dirittoDeselected.svg": [
		34584,
		[
			4584
		]
	],
	"./disegnoTecnicoDeselected.svg": [
		95505,
		[
			5505
		]
	],
	"./economiaAziendaleDeselected.svg": [
		37833,
		[
			7833
		]
	],
	"./economiaPoliticaDeselected.svg": [
		8937,
		[
			8937
		]
	],
	"./elettrotecnicaEdElettronicaDeselected.svg": [
		39674,
		[
			9674
		]
	],
	"./estimoDeselected.svg": [
		23270,
		[
			3270
		]
	],
	"./filosofiaDeselected.svg": [
		10851,
		[
			851
		]
	],
	"./fisicaDeselected.svg": [
		72224,
		[
			2224
		]
	],
	"./franceseDeselected.svg": [
		8702,
		[
			8702
		]
	],
	"./geografiaDeselected.svg": [
		62994,
		[
			2994
		]
	],
	"./grecoDeselected.svg": [
		33827,
		[
			3827
		]
	],
	"./informaticaDeselected.svg": [
		46312,
		[
			6312
		]
	],
	"./ingleseDeselected.svg": [
		27808,
		[
			7808
		]
	],
	"./italianoDeselected.svg": [
		76808,
		[
			6808
		]
	],
	"./latinoDeselected.svg": [
		76618,
		[
			6618
		]
	],
	"./matematicaDeselected.svg": [
		77587,
		[
			7587
		]
	],
	"./meccanicaDeselected.svg": [
		23487,
		[
			3487
		]
	],
	"./musicaDeselected.svg": [
		67909,
		[
			7909
		]
	],
	"./scienzeDellaTerraDeselected.svg": [
		56848,
		[
			6848
		]
	],
	"./scienzeDeselected.svg": [
		79568,
		[
			9568
		]
	],
	"./scienzeUmaneDeselected.svg": [
		87892,
		[
			7892
		]
	],
	"./sistemiAutomaticiDeselected.svg": [
		69599,
		[
			9599
		]
	],
	"./sistemiERetiDeselected.svg": [
		67188,
		[
			7188
		]
	],
	"./spagnoloDeselected.svg": [
		78092,
		[
			8092
		]
	],
	"./storiaDellArteDeselected.svg": [
		69466,
		[
			9466
		]
	],
	"./storiaDeselected.svg": [
		7679,
		[
			7679
		]
	],
	"./tecnologiaDeselected.svg": [
		97072,
		[
			7072
		]
	],
	"./tecnologieChimicheIndustrialiDeselected.svg": [
		68252,
		[
			8252
		]
	],
	"./tedescoDeselected.svg": [
		87200,
		[
			7200
		]
	],
	"./telecomunicazioniDeselected.svg": [
		10725,
		[
			725
		]
	],
	"./topografiaDeselected.svg": [
		87431,
		[
			7431
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 1 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 11756;
module.exports = webpackAsyncContext;